// extracted by mini-css-extract-plugin
export default {"button":"CourierAddressInput_button__ArEe4"};